
define("Code25.ReorderItems.Model", ["Backbone", "Utils"], function (
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.CachedModel.extend({
        //@property {String} urlRoot
        urlRoot: '/s/services/ReorderItems.Service.ss',
        parse: function parse(record) {
            return record;
        }
    });
});

